import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BundleCard } from "../components/BundleCard";
import { Layers } from "lucide-react";

export default function Bundles() {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products", { params: { category: "Research Bundles" } })
      .then((r) => setBundles(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#070B1C] min-h-screen" data-testid="bundles-page">
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(circle at 70% 30%, rgba(110,96,255,0.20), transparent 55%)" }} />
        <div className="relative max-w-[1100px] mx-auto px-5 lg:px-8 pt-20 lg:pt-28 pb-14 lg:pb-16">
          <div className="flex items-center gap-2 mb-5">
            <Layers size={18} className="text-electric" />
            <span className="text-[10px] tracking-[0.32em] uppercase font-bold text-electric">Research protocols</span>
          </div>
          <h1 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tighter uppercase leading-[0.95] text-white max-w-3xl">
            Curated protocols. One documented order.
          </h1>
          <p className="text-base md:text-lg text-white/65 mt-7 max-w-2xl leading-relaxed">
            Each protocol pairs compounds that researchers run together, priced below the cost
            of buying every vial on its own. Every component ships with a certificate matched to its lot.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 lg:px-8 py-14 lg:py-20">
        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="border border-white/12 aspect-[3/4] bg-[#0E1430] animate-pulse sq-lg" />
            ))}
          </div>
        ) : bundles.length === 0 ? (
          <p className="py-20 text-center text-sm tracking-[0.2em] uppercase text-white/40">No stacks available right now</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" data-testid="bundles-grid">
            {bundles.map((b, i) => (
              <BundleCard key={b.id} product={b} index={i} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
